import { Divider } from 'antd';
import styled from 'styled-components';
export const CustomDivider = styled(Divider).withConfig({
  displayName: "Dividerstyle__CustomDivider",
  componentId: "sc-kso71c-0"
})(["", ""], {
  "marginTop": "1rem",
  "marginBottom": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(235 235 235 / var(--tw-border-opacity, 1))"
});